import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AiPromptsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-prompts'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      props: {
        headerTitle: 'AI_PROMPTS_SETTINGS.TITLE',
        icon: 'i-lucide-sparkles',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'ai_prompts_settings',
          component: AiPromptsIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
